import {Box, Center, GridItem, Spinner} from "@chakra-ui/react";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from 'react-router-dom';
import PropertyBanner from "../components/PropertyBanner";
import PropertyTable from "../components/PropertyTable";
import PropertyMap from "../components/PropertyMap";
import About from "../components/About";
import Related from "../components/Related";
import {
  trackHeapPageView,
  defaultHeapOptions,
} from "../components/HeapAnalytics";
import Interested from "../components/Interested";
import {Helmet} from "react-helmet";
import {absoluteUrl, metaDescription, propertyName, propertyUrl} from "../components/Utils";


const PropertyPage = (props) => {
  const [propertyDetail, setPropertyDetail] = useState([]);
  const location = useLocation();

  if (!location.state) {
    location.state = {};
  }

  location.state.isPropertyPage = true;

  const [isLoader, setIsLoader] = useState(false)

  useEffect(() => {
    let urlQuery = new URLSearchParams(location.search);
    const propertyId = urlQuery.get('propertyId') || props.match?.params?.propertyId
    if (propertyId) {
      setIsLoader(true)
      fetch("/properties/" + propertyId + ".json", { mode: "cors" })
        .then((response) => response.json())
        .then(async (data) => {
          setPropertyDetail(data);
        })
        .catch((error) => {

          console.error(error)
          window.location.href = '/search';
        });
        setIsLoader(false)
    }
    else {

      window.location.href = '/search';
    }
  }, [location.search]);

  // Track property pageviews in heap
  useEffect(() => {
    if (propertyDetail && Object.keys(propertyDetail).length) {
      // Update yardi code in the dom
      const property = propertyDetail.sourceid ?? defaultHeapOptions.property;
      const heapDiv = document.querySelector('#heap-property');

      if (heapDiv) {
        heapDiv.setAttribute('data-heap-property', property);
      }

      trackHeapPageView({ property });
    }
  }, [propertyDetail]);

  return (
    <>
      <Helmet>
        <title>
          {`Welltower Medical Office For Lease in ${propertyDetail?.city?.name}, ${propertyDetail?.state} - ${propertyName(propertyDetail)}`}
        </title>
        <meta name="description" content={metaDescription(propertyDetail)} />
        <link rel="canonical" href={ absoluteUrl(propertyUrl(propertyDetail))} />
      </Helmet>
      {propertyDetail?.name && !isLoader?
        <Box pt={"91px"}>
          <PropertyBanner propertyDetail={propertyDetail} />
          <PropertyTable propertyDetail={propertyDetail} />
          <PropertyMap propertyDetail={propertyDetail} />
          {propertyDetail && !propertyDetail.available ? "" :
            <About propertyDetail={propertyDetail} />}
          <Interested propertyDetail={propertyDetail}  />
          <Related propertyDetail={propertyDetail} />
        </Box>
        :
          <GridItem>
            <Center h={"150px"} w={"100%"}>
              <Spinner thickness="4px" speed="2s" colorScheme="gray" w={"100px"} h={"100px"} />
            </Center>
          </GridItem>
      }
    </>
  );
};

export default PropertyPage;
